import * as tslib_1 from "tslib";
import * as React from 'react';
import { Link } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import AppBar from 'material-ui/AppBar';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import { routeCollection } from 'src/routes';
var LOGIN_COLOR = '#fff';
var LOGOUT_COLOR = 'rgb(7, 140, 158)';
var styles = {
    header: {
        paddingRight: 0
    },
    title: {
        fontSize: '16px'
    },
    link: {
        margin: '0 .5rem',
        height: '45px',
        color: 'white',
        fontSize: '15px',
        textDecoration: 'none',
    }
};
var AppHeader = /** @class */ (function (_super) {
    tslib_1.__extends(AppHeader, _super);
    function AppHeader(props) {
        var _this = _super.call(this, props) || this;
        _this.handleMenuClick = function (e) {
            e.preventDefault();
            _this.props.preferencesStore.isSettingsOpened = true;
        };
        return _this;
    }
    AppHeader.prototype.render = function () {
        var _this = this;
        var isAuthenticated = this.props.userStore.isAuthenticated;
        var navigationLinks = !isAuthenticated ? [] : routeCollection
            .getVisibleRoutes(this.props.userStore, this.props.projectStore)
            .map(function (i) { return (React.createElement(Link, { key: i.path, to: i.path, style: styles.link }, i.element ? [i.title, i.element(_this.props.userStore)] : i.title)); });
        var loginButton = React.createElement(IconButton, { key: 'auth', style: { top: '5px' }, onClick: !isAuthenticated ? this.props.onLogin : this.props.onLogout },
            React.createElement(FontIcon, { color: isAuthenticated ? LOGIN_COLOR : LOGOUT_COLOR, className: "material-icons" }, "power_settings_new"));
        var buttons = navigationLinks.concat([loginButton]);
        var menuButton = (React.createElement(IconButton, { onClick: this.handleMenuClick },
            React.createElement(FontIcon, { color: "white", className: "material-icons" }, "menu")));
        return (React.createElement(AppBar, { style: styles.header, titleStyle: styles.title, iconElementLeft: menuButton, iconElementRight: null, title: this.renderTitle() },
            React.createElement("div", null, buttons)));
    };
    AppHeader.prototype.renderTitle = function () {
        var _a = this.props.userStore, isAuthenticated = _a.isAuthenticated, userName = _a.userName, environment = _a.environment;
        return (React.createElement("div", null, isAuthenticated ? userName + "@" + environment : 'Boardy'));
    };
    AppHeader = tslib_1.__decorate([
        inject('userStore', 'preferencesStore', 'projectStore'),
        observer
    ], AppHeader);
    return AppHeader;
}(React.Component));
export default AppHeader;



//////////////////
// WEBPACK FOOTER
// ./src/layout/AppHeader.tsx
// module id = 609
// module chunks = 0